/**
 * This component was generated by the icon-component-creation.mjs script. PLEASE DO NOT EDIT THIS FILE DIRECTLY.
 */

import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const CeilingsIcon = createSvgIcon(
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 43 42"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: '2' }}
  >
    <g transform="matrix(1,0,0,1,-190,-1181)">
      <g id="Ceilings-" transform="matrix(0.542569,0,0,0.571048,170.006,377.641)">
        <g transform="matrix(0.632127,-2.57388e-16,-1.00628e-16,0.600602,-1525.59,1407.09)">
          <g id="backing">
            <path
              d="M2594.75,19.851L2594.75,102.551C2594.75,113.507 2585.85,122.401 2574.9,122.401L2492.2,122.401C2481.24,122.401 2472.35,113.507 2472.35,102.551L2472.35,19.851C2472.35,8.895 2481.24,0 2492.2,0L2574.9,0C2585.85,0 2594.75,8.895 2594.75,19.851Z"
              style={{ fill: 'none' }}
            />
          </g>
        </g>
        <g transform="matrix(3.24119e-17,-0.0454735,0.0332711,4.56567e-05,37.4289,1526.35)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(3.24016e-17,-0.0454735,0.0335911,4.60959e-05,67.2045,1526.45)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.0329628,-0.0329628,0.0308177,0.0309024,22.0188,1487.76)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(-0.0329628,-0.0329628,-0.0311133,0.0311989,130.333,1487.5)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.92686,0,0,0.92686,5.49173,107.127)">
          <g transform="matrix(-0.035564,-0.035564,-0.118191,0.118516,202.394,1407.49)">
            <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
          </g>
          <g transform="matrix(0.035564,-0.035564,0.118191,0.118516,-50.1532,1407.49)">
            <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
          </g>
        </g>
        <g transform="matrix(0.260143,2.05606e-32,-5.65416e-32,0.2605,-353.192,1206.64)">
          <circle cx="1650" cy="921.405" r="24.188" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(-6.40598e-19,-0.0454735,-0.180593,0.000247821,204.316,1537.15)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(-0.0478501,-8.02557e-18,6.3971e-05,0.0466171,129.147,1431.74)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(-0.0478501,-8.02557e-18,6.3971e-05,0.0466171,187.451,1431.83)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
      </g>
    </g>
  </svg>,
  'CeilingsIcon',
);
